<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Medical Gastroenterology</h2>
      <p>
        The services of a consultant in Medical Gastroenterology who performs
        upper GI endoscopy amd Colonoscopy.
      </p>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate2.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Medical Gastroenterology Doctors",
      queryName: "Medical Gastroenterology",
      teamName: "Medical Gastroenterology team",
    };
  },
  components: { DoctorsList },
});
</script>

<style scoped lang="scss">
@import "@/scss/sectionTemplate2.scss";
</style>
